import { render, staticRenderFns } from "./DeliveryArea.vue?vue&type=template&id=64f27742&scoped=true"
import script from "./DeliveryArea.vue?vue&type=script&lang=js"
export * from "./DeliveryArea.vue?vue&type=script&lang=js"
import style0 from "./DeliveryArea.vue?vue&type=style&index=0&id=64f27742&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f27742",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f27742')) {
      api.createRecord('64f27742', component.options)
    } else {
      api.reload('64f27742', component.options)
    }
    module.hot.accept("./DeliveryArea.vue?vue&type=template&id=64f27742&scoped=true", function () {
      api.rerender('64f27742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/form/DeliveryArea.vue"
export default component.exports